import { JSONPost, post } from '../services/routes';

export const login = (user, url='/users/login') => post(user, url);
export const googleLogin = (token) => JSONPost({ token }, '/users/googleLogin');
export const googleSignup = data => JSONPost(data, '/users/googleRegister');
export const signup = (user, url='/users/register') => post(user, url);
export const verifyEmail = (data, url='/users/verify-email') => post(data, url);
